var _defs, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.76 172.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #048988;\n        stroke-width: 0px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 57.54,
    cy: 75.95,
    r: 13.24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 90.16,
    cy: 75.95,
    r: 13.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m147.87,104.23c0,7.44-1.86,14.01-5.58,19.71-3.72,5.7-8.91,10.15-15.57,13.33-6.66,3.18-14.43,4.77-23.31,4.77h-54.68c-6.05,0-11.85,2.43-16.09,6.75l-4.98,5.08-2.21,2.25c-.15.2-.31.39-.48.57h0c-1.27,1.37-3.08,2.22-5.09,2.22-3.86,0-6.98-3.13-6.98-6.98v-51.52c.35-2.75,2.69-4.87,5.53-4.87h20.35c3.08,0,5.58,2.5,5.58,5.58v16c2.56-.67,5.21-1.01,7.91-1.01h29.51v.05h19.06c5.68,0,10.28-4.6,10.28-10.28v-24.32c0-.1.01-.2.01-.31.03-1.07.04-2.17.04-3.3,0-.4,0-.8,0-1.2,0-.4,0-.79-.01-1.18v-.21c-.01-.37-.01-.73-.03-1.08v-24.27c0-5.68-4.6-10.28-10.28-10.28h-19.06v.05h-28.71c-4.81,0-8.71-3.9-8.71-8.71v-8.51c0-4.81,3.9-8.71,8.71-8.71h50.34c8.78,0,16.47,1.55,23.08,4.66,5.59,2.92,9.95,6.85,13.1,11.81,3.24,5.11,4.86,10.95,4.86,17.55,0,9.13-3.24,16.57-9.72,22.33-.02.02-.04.04-.06.05-2.09,1.84-1.97,5.06.23,6.76.39.3.77.61,1.14.93.35.29.69.59,1.03.9,7.2,6.6,10.8,15.06,10.8,25.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.287c8cb2adc1ae5e7ee2153c9e36143f.svg";
export { ForwardRef as ReactComponent };